import { propOr, compose, find, propEq } from 'ramda';

type StateViewportPreset = {
  latitude: number;
  longitude: number;
  zoom: number;
};

type StateRecord = {
  abbr: string;
  name: string;
};

const stateViewportPresets: Record<string, StateViewportPreset> = {
  AL: {
    latitude: 32.74693182531916,
    longitude: -86.35072387878114,
    zoom: 5.567521645302304,
  },
  AK: {
    latitude: 63.73438841126979,
    longitude: -152.49777343235615,
    zoom: 2.7579950296774016,
  },
  AZ: {
    latitude: 34.3206741861256,
    longitude: -111.85231415397563,
    zoom: 5.1816016118119625,
  },
  AR: {
    latitude: 34.74220310831685,
    longitude: -91.88130806581253,
    zoom: 5.777090925580273,
  },
  CA: {
    latitude: 37.526,
    longitude: -119.058,
    zoom: 4.468,
  },
  CO: {
    latitude: 39.0232335934082,
    longitude: -105.29396584475715,
    zoom: 5.489383846266217,
  },
  CT: {
    latitude: 41.50790005066726,
    longitude: -72.69713720600983,
    zoom: 7.364394433021533,
  },
  DE: {
    latitude: 39.152023658553226,
    longitude: -75.1754195596277,
    zoom: 7.1066056308481595,
  },
  undefined: {
    latitude: 38.896470846211365,
    longitude: -76.99456118343059,
    zoom: 9.973807341132728,
  },
  FL: {
    latitude: 28.237409708967604,
    longitude: -81.98972352977434,
    zoom: 5.273204874256543,
  },
  GA: {
    latitude: 32.832035300103655,
    longitude: -82.6061719361512,
    zoom: 5.531375170490134,
  },
  HI: {
    latitude: 20.565135089203558,
    longitude: -156.9493126425395,
    zoom: 5.9695310327406705,
  },
  ID: {
    latitude: 45.511981133142896,
    longitude: -114.05981710344764,
    zoom: 4.657035568543421,
  },
  IL: {
    latitude: 39.87406562146008,
    longitude: -88.70816648862507,
    zoom: 5.105329649245594,
  },
  IN: {
    latitude: 39.81634584369276,
    longitude: -85.98894840200838,
    zoom: 5.562087379694339,
  },
  IA: {
    latitude: 42.03950985960197,
    longitude: -93.31624953689229,
    zoom: 5.862709698539833,
  },
  KS: {
    latitude: 38.52668954067257,
    longitude: -98.02647063385157,
    zoom: 5.867284515136019,
  },
  KY: {
    latitude: 37.852498190075636,
    longitude: -85.23789143281796,
    zoom: 6.159730187380279,
  },
  LA: {
    latitude: 31.052079010964217,
    longitude: -91.61619345772903,
    zoom: 5.718640180819968,
  },
  ME: {
    latitude: 45.458919304251246,
    longitude: -68.48423064179521,
    zoom: 5.326355062040479,
  },
  MD: {
    latitude: 39.045753,
    longitude: -76.641273,
    zoom: 6.266971641482853,
  },
  MA: {
    latitude: 42.12988431427078,
    longitude: -71.71801821844258,
    zoom: 6.987335279996832,
  },
  MI: {
    latitude: 45.17853934965816,
    longitude: -86.41947752290051,
    zoom: 4.5610590335527785,
  },
  MN: {
    latitude: 46.13362180198093,
    longitude: -92.65062173095984,
    zoom: 4.83941080980371,
  },
  MS: {
    latitude: 32.68472793653213,
    longitude: -89.21983499247278,
    zoom: 5.3169339654270225,
  },
  MO: {
    latitude: 38.1579596880014,
    longitude: -91.68927487451923,
    zoom: 5.234782224158886,
  },
  MT: {
    latitude: 46.637577752046646,
    longitude: -110.48111226576037,
    zoom: 5.073437216714606,
  },
  NE: {
    latitude: 41.655,
    longitude: -99.49,
    zoom: 5.6334,
  },
  NV: {
    latitude: 38.74045831294825,
    longitude: -116.42035855037697,
    zoom: 4.767118430819708,
  },
  NH: {
    latitude: 44.030678430579925,
    longitude: -71.1156154568447,
    zoom: 6.031184845482273,
  },
  NJ: {
    latitude: 40.13585756945178,
    longitude: -74.322201379123,
    zoom: 6.325555872007102,
  },
  NM: {
    latitude: 34.44057623302551,
    longitude: -105.40675458572784,
    zoom: 5.100354202097684,
  },
  NY: {
    latitude: 42.72196563980931,
    longitude: -75.55931848350073,
    zoom: 5.17796405215935,
  },
  NC: {
    latitude: 35.36772602839218,
    longitude: -79.52182215592455,
    zoom: 5.858158524111385,
  },
  ND: {
    latitude: 47.28748110930202,
    longitude: -100.31693491892081,
    zoom: 5.521470235694476,
  },
  OH: {
    latitude: 40.15297529801981,
    longitude: -82.27396468694405,
    zoom: 5.644271910785306,
  },
  OK: {
    latitude: 35.334789146422885,
    longitude: -98.59025880287562,
    zoom: 5.750742360723636,
  },
  OR: {
    latitude: 44.335038486185226,
    longitude: -121.29114262411315,
    zoom: 5.116727525546749,
  },
  PA: {
    latitude: 41.055,
    longitude: -77.383,
    zoom: 5.868,
  },
  RI: {
    latitude: 41.62404389767834,
    longitude: -71.35080919796107,
    zoom: 7.3410425714404735,
  },
  SC: {
    latitude: 33.668321642221514,
    longitude: -80.68919614468734,
    zoom: 5.772725694769232,
  },
  SD: {
    latitude: 44.52037600416565,
    longitude: -100.05513144048409,
    zoom: 5.409146628355796,
  },
  TN: {
    latitude: 35.950386352734384,
    longitude: -85.75511508102684,
    zoom: 5.894959634519377,
  },
  TX: {
    latitude: 31.646,
    longitude: -99.555,
    zoom: 4.365,
  },
  UT: {
    latitude: 39.576885242379724,
    longitude: -111.09564357864456,
    zoom: 5.124003004701778,
  },
  VT: {
    latitude: 43.88611434213974,
    longitude: -72.35182896121606,
    zoom: 6.160533757491133,
  },
  VA: {
    latitude: 38.00314508111078,
    longitude: -79.22104617160315,
    zoom: 5.89683402800472,
  },
  WA: {
    latitude: 47.348,
    longitude: -120.177,
    zoom: 5.412,
  },
  WV: {
    latitude: 38.950583465884705,
    longitude: -80.31965620545364,
    zoom: 5.918215174249361,
  },
  WI: {
    latitude: 44.66926443587101,
    longitude: -88.95532367130579,
    zoom: 5.149676807445127,
  },
  WY: {
    latitude: 42.98338662928203,
    longitude: -107.12377328288787,
    zoom: 5.4769063379281775,
  },
};

const states: StateRecord[] = [
  { abbr: 'AL', name: 'Alabama' },
  { abbr: 'AK', name: 'Alaska' },
  { abbr: 'AZ', name: 'Arizona' },
  { abbr: 'AR', name: 'Arkansas' },
  { abbr: 'CA', name: 'California' },
  { abbr: 'CO', name: 'Colorado' },
  { abbr: 'CT', name: 'Connecticut' },
  { abbr: 'DC', name: 'District Of Columbia' },
  { abbr: 'DE', name: 'Delaware' },
  { abbr: 'FL', name: 'Florida' },
  { abbr: 'GA', name: 'Georgia' },
  { abbr: 'HI', name: 'Hawaii' },
  { abbr: 'ID', name: 'Idaho' },
  { abbr: 'IL', name: 'Illinois' },
  { abbr: 'IN', name: 'Indiana' },
  { abbr: 'IA', name: 'Iowa' },
  { abbr: 'KS', name: 'Kansas' },
  { abbr: 'KY', name: 'Kentucky' },
  { abbr: 'LA', name: 'Louisiana' },
  { abbr: 'ME', name: 'Maine' },
  { abbr: 'MD', name: 'Maryland' },
  { abbr: 'MA', name: 'Massachusetts' },
  { abbr: 'MI', name: 'Michigan' },
  { abbr: 'MN', name: 'Minnesota' },
  { abbr: 'MS', name: 'Mississippi' },
  { abbr: 'MO', name: 'Missouri' },
  { abbr: 'MT', name: 'Montana' },
  { abbr: 'NE', name: 'Nebraska' },
  { abbr: 'NV', name: 'Nevada' },
  { abbr: 'NH', name: 'New Hampshire' },
  { abbr: 'NJ', name: 'New Jersey' },
  { abbr: 'NM', name: 'New Mexico' },
  { abbr: 'NY', name: 'New York' },
  { abbr: 'NC', name: 'North Carolina' },
  { abbr: 'ND', name: 'North Dakota' },
  { abbr: 'OH', name: 'Ohio' },
  { abbr: 'OK', name: 'Oklahoma' },
  { abbr: 'OR', name: 'Oregon' },
  { abbr: 'PA', name: 'Pennsylvania' },
  { abbr: 'RI', name: 'Rhode Island' },
  { abbr: 'SC', name: 'South Carolina' },
  { abbr: 'SD', name: 'South Dakota' },
  { abbr: 'TN', name: 'Tennessee' },
  { abbr: 'TX', name: 'Texas' },
  { abbr: 'UT', name: 'Utah' },
  { abbr: 'VT', name: 'Vermont' },
  { abbr: 'VA', name: 'Virginia' },
  { abbr: 'WA', name: 'Washington' },
  { abbr: 'WV', name: 'West Virginia' },
  { abbr: 'WI', name: 'Wisconsin' },
  { abbr: 'WY', name: 'Wyoming' },
];

export const USStatesDropDownOptions = states.map(
  ({ abbr, name }: { abbr: string; name: string }) => ({
    key: name,
    text: name,
    value: abbr,
  }),
);

export const getStateFullName = (stateAbbr: string) =>
  compose(propOr('unknown', 'name'), find(propEq('abbr', stateAbbr)))(states);

export const getStateAbbr = (stateName: string) =>
  compose(propOr('unknown', 'abbr'), find(propEq('name', stateName)))(states);

export const getStateViewportPreset = (state: string) => {
  const stateToGet = state.length === 2 ? state : getStateAbbr(state);
  return stateViewportPresets[stateToGet as string];
};
